module.exports = __webpack_public_path__ + "static/media/title2.9919e534.jpg";